<template>
  <hb-basic-page
    :action-buttons="$vuetify.breakpoint.smAndDown ? { add: titleButton } : {}"
    :loading="loading"
    :noContainerPadding="$vuetify.breakpoint.xsOnly"
    :search-title="`${$t('tenants.search')}...`"
    :subtle-loading="subtleLoading"
    :title="$t('tenants.title')"
    :title-button="titleButton"
    name="tenants-list"
    no-gutters
    @handle-search="handleSearch"
  >
    <v-col v-if="filteredTenants.length > 0" :pb-5="$vuetify.breakpoint.xsOnly" cols="12">
      <v-list class="pa-0 pb-15" color="transparent" two-line>
        <v-list-item v-if="$vuetify.breakpoint.smAndUp" class="tenants-header">
          <v-list-item-avatar></v-list-item-avatar>
          <v-list-item-content class="grey--text">
            <v-container fluid ma-0 pa-0>
              <v-row align="center" class="fill-height" justify="center" ma-0>
                <v-col cols="12" lg="5" sm="6" xl="3">
                  <span class="caption">{{ $t('tenants.organization_name') }}</span>
                </v-col>
                <v-col cols="12" lg="7" sm="6" xl="9">
                  <span class="caption">{{ $t('tenants.status') }}</span>
                </v-col>
              </v-row>
            </v-container>
          </v-list-item-content>
          <v-list-item-action style="width: 36px"></v-list-item-action>
        </v-list-item>
        <v-divider v-if="$vuetify.breakpoint.smAndUp"></v-divider>

        <template v-for="tenant in filteredTenants">
          <tenant-list-item
            :key="tenant.id"
            :open-tenant-details="() => openTenantDetails(tenant)"
            :open-tenant-plan-dialog="() => openTenantPlanDialog(tenant)"
            :open-tenant-users-management="() => openTenantUsersManagement(tenant)"
            :tenant="tenant"
          />
          <v-divider :key="`${tenant.id}_divider`"></v-divider>
        </template>
      </v-list>
    </v-col>

    <tenant-plan-dialog ref="tenantPlanDialog" @on-dismiss="onTenantDetailsDialogDismiss"></tenant-plan-dialog>
    <tenant-details-dialog ref="tenantDetailsDialog" @on-dismiss="onTenantDetailsDialogDismiss"/>
    <users-dialog ref="usersDialog"/>
    <add-tenant-dialog ref="addTenantDialog" @on-dismiss="onAddTenantDialogDismiss"/>
  </hb-basic-page>
</template>

<script>
import AddTenantDialog from '../components/Tenants/AddTenantDialog';
import TenantDetailsDialog from '../components/Tenants/TenantDetailsDialog';
import UsersDialog from '../components/Tenants/UsersDialog';
import adminApi from '../api/admin';
import TenantPlanDialog from '@/components/Tenants/TenantPlanDialog';
import TenantListItem from '@/components/TenantListItem';

export default {
  name: 'TenantsView',
  components: {
    TenantListItem,
    TenantPlanDialog,
    AddTenantDialog: AddTenantDialog,
    TenantDetailsDialog: TenantDetailsDialog,
    UsersDialog: UsersDialog,
  },
  data() {
    return {
      tenants: [],
      subtleLoading: false,
      loading: true,
      searchPhrase: '',
      titleButton: {
        text: this.$t('tenants.add_new_tenant'),
        icon: 'add',
        callback: this.openAddTenantDialog,
        primary: true,
      },
    };
  },
  methods: {
    openTenantPlanDialog(tenant) {
      this.$refs.tenantPlanDialog.open(tenant);
    },
    openAddTenantDialog() {
      this.$refs.addTenantDialog.open();
    },
    handleSearch(searchPhrase) {
      this.searchPhrase = searchPhrase;
    },
    async loadTenants() {
      try {
        const tenants = await this.$adminApi.getTenants();
        this.tenants = tenants;
      } catch (error) {
        this.$handleApiError(error);
      }
    },
    async onAddTenantDialogDismiss() {
      this.subtleLoading = true;
      await this.loadTenants();
      this.subtleLoading = false;
    },
    async onTenantDetailsDialogDismiss() {
      this.subtleLoading = true;
      await this.loadTenants();
      this.subtleLoading = false;
    },
    openTenantDetails(tenant) {
      this.$refs.tenantDetailsDialog.open(tenant);
    },
    async toggleTenantState(tenant) {
      const status = this.isTenantEnabled(tenant) ? 'INACTIVE' : 'ACTIVE';
      const data = {
        name: tenant.name,
        status,
      };
      try {
        const updatedTenant = await adminApi.updateTenant(tenant.id, data);
        const tenantIndex = this.tenants.findIndex(t => t.id === updatedTenant.id);
        this.tenants.splice(tenantIndex, 1, updatedTenant);
      } catch (error) {
        this.$handleApiError(error);
      }
    },
    openTenantUsersManagement(tenant) {
      this.$refs.usersDialog.open(tenant);
    },
  },
  computed: {
    filteredTenants() {
      const filteredTenants = this.tenants;

      if (this.searchPhrase.length === 0) return filteredTenants;

      const searchPhraseLower = this.searchPhrase.toLowerCase();
      const searchPhraseArray = searchPhraseLower.split(' ');
      return filteredTenants.filter(tenant => {
        let found = [];
        const lowerSearchedString = tenant.name ? tenant.name.toLowerCase() : '';
        searchPhraseArray.forEach(phrase => {
          if (lowerSearchedString.indexOf(phrase) !== -1) {
            found.push(true);
          } else {
            found.push(false);
          }
        });
        /*
          if (filterOutActive && tenant.enabled) found.push(false);
          if (filterOutInactive && !tenant.enabled) found.push(false);
           */
        return found.indexOf(false) === -1;
      });
    },
  },
  async mounted() {
    if (!this.$hasMatchingRoles(['admin'])) {
      this.$router.replace({name: 'access_denied'});
      return;
    }
    this.loading = true;
    await this.loadTenants();
    this.loading = false;
  },
};
</script>
